import { DateTime } from "luxon";

/**
 * A  collection of security and entitlement related classes and interfaces.
 */
import { AccessLevel, AccountStatus, AccountType, CommonBaseModel, GuestAccountStatus, KeyValuePair } from "./common.model";
import { tryParseDate } from "../global.functions";

export class EntitlementSet extends CommonBaseModel {
    r: number[] = [];
    w: number[] = [];

    init(_data?: any): this {
        if (!_data || typeof _data !== 'object') {
            return this;
        }
        _data = _data["response"] ? _data["response"] : _data;

        if (Array.isArray(_data["R"])) {
            this.r = [];
            for (let item of _data["R"]) {
                this.r.push(item);
            }
        }

        if (Array.isArray(_data["W"])) {
            this.w = [];
            for (let item of _data["W"]) {
                this.w.push(item);
            }
        }

        return this;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["r"] = [];
        data["w"] = [];

        if (Array.isArray(this.r)) {
            for (let item of this.r)
                data["r"].push(item);
        }

        if (Array.isArray(this.w)) {
            for (let item of this.w)
                data["w"].push(item);
        }

        return data;
    }
}

/** A set of controls entitlements for appropriate form version, role and state. */
export class ControlEntitlementSet implements IControlEntitlementSet {
    /** Gets or sets the product ID. */
    formId!: string | undefined;
    /** Gets or sets the form version. */
    formVersion!: number;
    /** Gets or sets the role ID. */
    roleId!: string | undefined;
    /** Gets or sets the state name. */
    stateName!: string | undefined;
    /** Gets or sets the state GUID. */
    stateGuid!: string | undefined;
    /** Gets or sets the entitlements group. */
    entitlements: EntitlementSet | undefined = new EntitlementSet();
    id!: string | undefined;

    constructor(data?: IControlEntitlementSet) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.formVersion = _data["formVersion"];
            this.roleId = _data["roleId"];
            this.stateName = _data["stateName"];
            this.stateGuid = _data["stateGuid"];
            this.entitlements = _data["entitlements"] ? (new EntitlementSet()).init(_data["entitlements"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ControlEntitlementSet {
        data = typeof data === 'object' ? data : {};
        let result = new ControlEntitlementSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formVersion"] = this.formVersion;
        data["roleId"] = this.roleId;
        data["stateName"] = this.stateName;
        data["stateGuid"] = this.stateGuid;
        data["entitlements"] = this.entitlements ? this.entitlements.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

/** A set of controls entitlements for appropriate form version, role and state. */
export interface IControlEntitlementSet {
    /** Gets or sets the product ID. */
    formId: string | undefined;
    /** Gets or sets the form version. */
    formVersion: number;
    /** Gets or sets the role ID. */
    roleId: string | undefined;
    /** Gets or sets the state name. */
    stateName: string | undefined;
    /** Gets or sets the state GUID. */
    stateGuid: string | undefined;
    /** Gets or sets the entitlements group. */
    entitlements: EntitlementSet | undefined;
    id: string | undefined;
}

// /** Represents a control entitlements inside summary control. */
// export class SummaryControlEntitlement implements ISummaryControlEntitlement {
//     /** Gets or sets the summary control ID. */
//     summaryControlId!: number;
//     /** Gets or sets the entitlements group. */
//     entitlements: EntitlementSet | undefined = new EntitlementSet();

//     // /** Gets or sets the product ID. */
//     // formId!: string | undefined;
//     // /** Gets or sets the form version. */
//     // formVersion!: number;
//     // /** Gets or sets the role ID. */
//     // roleId!: string | undefined;
//     // /** Gets or sets the state name. */
//     // stateName!: string | undefined;
//     // /** Gets or sets the state GUID. */
//     // stateGuid!: string | undefined;
//     // id!: string | undefined;

//     constructor(data?: ISummaryControlEntitlement) {
//         if (data) {
//             for (let property in data) {
//                 if (data.hasOwnProperty(property))
//                     (<any>this)[property] = (<any>data)[property];
//             }
//         }
//     }

//     init(_data?: any) {
//         if (_data) {
//             this.summaryControlId = _data["summaryControlId"];
//             this.entitlements = _data["entitlements"] ? EntitlementSet.fromJS(_data["entitlements"]) : <any>undefined;
//             // this.formId = _data["formId"];
//             // this.formVersion = _data["formVersion"];
//             // this.roleId = _data["roleId"];
//             // this.stateName = _data["stateName"];
//             // this.stateGuid = _data["stateGuid"];
//             // this.id = _data["id"];
//         }
//     }

//     static fromJS(data: any): SummaryControlEntitlement {
//         data = typeof data === 'object' ? data : {};
//         let result = new SummaryControlEntitlement();
//         result.init(data);
//         return result;
//     }

//     toJSON(data?: any) {
//         data = typeof data === 'object' ? data : {};
//         data["summaryControlId"] = this.summaryControlId;
//         data["entitlements"] = this.entitlements ? this.entitlements.toJSON() : <any>undefined;
//         // data["formId"] = this.formId;
//         // data["formVersion"] = this.formVersion;
//         // data["roleId"] = this.roleId;
//         // data["stateName"] = this.stateName;
//         // data["stateGuid"] = this.stateGuid;
//         // data["id"] = this.id;
//         return data;
//     }
// }

// /** Represents a control entitlements inside summary control. */
// export interface ISummaryControlEntitlement {
//     /** Gets or sets the summary control ID. */
//     summaryControlId: number;
//     /** Gets or sets the entitlements group. */
//     entitlements: EntitlementSet | undefined;

//     // /** Gets or sets the product ID. */
//     // formId: string | undefined;
//     // /** Gets or sets the form version. */
//     // formVersion: number;
//     // /** Gets or sets the role ID. */
//     // roleId: string | undefined;
//     // /** Gets or sets the state name. */
//     // stateName: string | undefined;
//     // /** Gets or sets the state GUID. */
//     // stateGuid: string | undefined;
//     // id: string | undefined;
// }

/** Represents a metadata entitlement setting. */
export class MetadataEntitlement extends CommonBaseModel {
    /** Gets or sets the page ID. */
    controlName!: string | undefined;
    accessLevel: AccessLevel = AccessLevel.NoAccess;

    init(_data?: any): this {
        if (!_data || typeof _data !== 'object') {
            return this;
        }
        _data = _data["response"] ? _data["response"] : _data;

        super.init(_data);

        this.controlName = _data["ControlName"] ?? _data["controlName"];
        this.accessLevel = _data["Value"] ?? _data["value"] ??
            _data["AccessLevel"] ?? _data["accessLevel"] ?? AccessLevel.NoAccess;
        return this;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controlName"] = this.controlName;
        data["accessLevel"] = this.accessLevel;
        // data["formId"] = this.formId;
        // data["formVersion"] = this.formVersion;
        // data["roleId"] = this.roleId;
        // data["stateName"] = this.stateName;
        // data["stateGuid"] = this.stateGuid;
        // data["id"] = this.id;
        return data;
    }
}

/** The response object returned from authentication requests. */
export class AuthResponse implements IAuthResponse {
    success: boolean;
    twoFactorActivationRequired: boolean | undefined;
    twoFactorAuthenticationRequired: boolean | undefined;
    user: User;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.twoFactorActivationRequired = _data["TwoFactorActivationRequired"];
            this.twoFactorAuthenticationRequired = _data["TwoFactorAuthenticationRequired"];
            this.success = _data["Success"];
            this.user = _data["User"] ? User.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TwoFactorActivationRequired"] = this.twoFactorActivationRequired;
        data["TwoFactorAuthenticationRequired"] = this.twoFactorAuthenticationRequired;
        data["Success"] = this.success;
        data["User"] = this.user ? JSON.stringify(this.user) : <any>undefined;
        return data;
    }
}

/** The response object returned from authentication requests. */
export interface IAuthResponse {
    success: boolean;
    twoFactorActivationRequired: boolean | undefined;
    twoFactorAuthenticationRequired: boolean | undefined;
    user: User;
}

/** An authentication request input. */
export class AuthenticationInput implements IAuthenticationInput {
    /** Gets or sets the Username. */
    username!: string | undefined;
    /** Gets or sets the Password. */
    password!: string | undefined;
    /** Gets or sets a flag indicating the users choice to remember the session. */
    keepMeSignedIn!: boolean;

    constructor(data?: IAuthenticationInput) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.keepMeSignedIn = _data["keepMeSignedIn"] ?? false;
        }
    }

    static fromJS(data: any): AuthenticationInput {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["keepMeSignedIn"] = this.keepMeSignedIn ?? false;
        data["workbench"] = false;
        return data;
    }
}

/** An authentication request input. */
export interface IAuthenticationInput {
    /** Gets or sets the Username. */
    username: string | undefined;
    /** Gets or sets the Password. */
    password: string | undefined;
    /** Gets or sets a flag indicating the users choice to remember the session. */
    keepMeSignedIn: boolean;
}

/** Two Factor Credentials Response */
export class TwoFactorCredentialsResponse implements ITwoFactorCredentialsResponse {
    /** Gets or sets a value indicating whether it is success. */
    success!: boolean;
    /** Gets or sets Two Factor Credentials. */
    credentials!: TwoFactorCredentials | undefined;

    constructor(data?: ITwoFactorCredentialsResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.credentials = _data["Credentials"] ? TwoFactorCredentials.fromJS(_data["Credentials"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TwoFactorCredentialsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorCredentialsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        data["Credentials"] = this.credentials ? this.credentials.toJSON() : <any>undefined;
        return data;
    }
}

/** Two Factor Credentials Response */
export interface ITwoFactorCredentialsResponse {
    success: boolean;
    credentials: TwoFactorCredentials | undefined;
}

/** two-factor-authentication credential */
export class TwoFactorCredentials implements ITwoFactorCredentials {
    /**  Gets or sets the identity of the two-factor-authentication credentials. */
    identity!: string | undefined;
    /** Gets or sets the identity of the issuing website. */
    issuer!: string | undefined;
    /** Gets the decrypted secret. */
    decryptedSecret!: string | undefined;
    /** Gets or sets the URL for the QR-Code associated with these credentials. */
    qrCodeUrl!: string | undefined;
    /**  Gets the OTP auth data url for the QR-Code associated with these credentials. */
    otpData!: string | undefined;

    constructor(data?: ITwoFactorCredentials) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identity = _data["Identity"];
            this.issuer = _data["Issuer"];
            this.decryptedSecret = _data["DecryptedSecret"];
            this.qrCodeUrl = _data["QrCodeUrl"];
            this.otpData = _data["OtpData"];
        }
    }

    static fromJS(data: any): TwoFactorCredentials {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorCredentials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Identity"] = this.identity;
        data["Issuer"] = this.issuer;
        data["DecryptedSecret"] = this.decryptedSecret;
        data["QrCodeUrl"] = this.qrCodeUrl;
        data["OtpData"] = this.otpData;
        return data;
    }
}

/** two-factor-authentication credential */
export interface ITwoFactorCredentials {
    /**  Gets or sets the identity of the two-factor-authentication credentials. */
    identity: string | undefined;
    /** Gets or sets the identity of the issuing website. */
    issuer: string | undefined;
    /** Gets the decrypted secret. */
    decryptedSecret: string | undefined;
    /** Gets or sets the URL for the QR-Code associated with these credentials. */
    qrCodeUrl: string | undefined;
    /**  Gets the OTP auth data url for the QR-Code associated with these credentials. */
    otpData: string | undefined;
}

/** User details. */
export class UserBase implements IUserBase {
    /** Gets or sets the identifier. */
    id!: string | undefined;
    /**  The list of extended properties. */
    extendedProperties!: { [key: string]: string; } | undefined;
    /** Gets or sets the display name. */
    displayName!: string | undefined;
    /** Gets or sets the email address */
    emailAddress!: string | undefined;
    /** Gets or sets an external identifier used to authenticate against third-party Authentication providers. */
    externalId!: string | undefined;

    constructor(data?: IUserBase) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["_id"]?.$oid;
            this.displayName = _data["DisplayName"];
            this.emailAddress = _data["EmailAddress"];
            this.externalId = _data["ExternalId"];
            if (_data["ExtendedProperties"]) {
                this.extendedProperties = {} as any;
                for (let key in _data["ExtendedProperties"]) {
                    if (_data["ExtendedProperties"].hasOwnProperty(key))
                        (<any>this.extendedProperties)![key] = _data["ExtendedProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): UserBase {
        data = typeof data === 'object' ? data : {};
        let result = new UserBase();
        result.init(data);
        return result;
    }
}

/** User details. */
export interface IUserBase {
    /** Gets or sets the identifier. */
    id: string | undefined;
    /**  The list of extended properties. */
    extendedProperties: { [key: string]: string; } | undefined;
    /** Gets or sets the display name. */
    displayName: string | undefined;
    /** Gets or sets the email address */
    emailAddress: string | undefined;
    /** Gets or sets an external identifier used to authenticate against third-party Authentication providers. */
    externalId: string | undefined;
}

/** UserWithEntitlements */
export class User extends UserBase implements IUser {
    /**  Gets or sets the username. */
    username: string | undefined;
    /** Gets or sets the DateTime the account was last locked. */
    lockedSince: DateTime | undefined;
    /** Gets or sets the DateTime the last security event email was sent. */
    securityNotificationSent: DateTime | undefined;
    /** Gets or sets the list of disabled organisations the user is entitled to. */
    organisationsDisabled: { [key: string]: string; } | undefined;
    /** Gets or sets a value indicating whether Two Factor Authentication is enabled for this user. */
    twoFactorAuthenticationEnabled: boolean;
    /** Gets or sets the account status property. */
    accountStatus: AccountStatus;
    /** Gets or sets the account type property. */
    accountType: AccountType;
    /** Gets or sets the property reset property. */
    passwordReset: PasswordReset | undefined;
    /** Gets or sets the list of enabled organisations the user is entitled to. */
    organisations: KeyValuePair[];
    /**  Gets or sets the list of roles. */
    roles: KeyValuePair[];
    /** Gets or sets a value indicating whether the user can access the form vault. */
    formVaultAccess?: boolean | undefined;
    /** Gets or sets the list of system entitlements. */
    systemEntitlements?: { [key: string]: AccessLevel; } | undefined;
    /** Gets or sets a value indicating whether
     * this iSolutions.iApply.DataContract.Security.UserWithEntitlements is a singly-signed-on user. */
    sso?: boolean | undefined;
    /** Gets or sets a value indicating whether single-signed-on user can sign out. */
    ssoWithLogout?: boolean | undefined;
    /** Gets or sets a value for SessionTimeOut. */
    sessionTimeOut?: number | undefined;
    /** Gets or sets a value for SessionIntervalCheck. */
    sessionIntervalCheck?: number | undefined;
    /** avatar (not in this version) */
    avatar?: string | undefined;

    constructor(data?: IUser) {
        super(data);
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["_id"]?.$oid;
            this.displayName = _data["DisplayName"];
            this.username = _data["Username"];
            this.emailAddress = _data["EmailAddress"];
            this.avatar = _data["Avatar"];
            this.externalId = _data["ExternalId"];
            this.accountStatus = _data["AccountStatus"];
            this.accountType = _data["AccountType"];
            this.passwordReset = _data["PasswordReset"];
            this.sso = _data["Sso"];
            this.ssoWithLogout = _data["SsoWithLogout"];
            this.sessionTimeOut = _data["SessionTimeOut"];
            this.sessionIntervalCheck = _data["SessionIntervalCheck"];
            if (_data["SystemEntitlements"]) {
                this.systemEntitlements = {} as any;
                for (let key in _data["SystemEntitlements"]) {
                    if (_data["SystemEntitlements"].hasOwnProperty(key))
                        (<any>this.systemEntitlements)![key] = _data["SystemEntitlements"][key];
                }
            }
            if (_data["ExtendedProperties"]) {
                this.extendedProperties = {} as any;
                for (let key in _data["ExtendedProperties"]) {
                    if (_data["ExtendedProperties"].hasOwnProperty(key))
                        (<any>this.extendedProperties)![key] = _data["ExtendedProperties"][key];
                }
            }
            if (_data["OrganisationsDisabled"]) {
                this.organisationsDisabled = {} as any;
                for (let key in _data["OrganisationsDisabled"]) {
                    if (_data["OrganisationsDisabled"].hasOwnProperty(key))
                        (<any>this.organisationsDisabled)![key] = _data["OrganisationsDisabled"][key];
                }
            }
            this.twoFactorAuthenticationEnabled = _data["TwoFactorAuthenticationEnabled"];
            this.securityNotificationSent = _data["SecurityNotificationSent"] ? DateTime.fromISO(_data["SecurityNotificationSent"].toString()) : <any>undefined;
            this.lockedSince = _data["LockedSince"] ? DateTime.fromISO(_data["LockedSince"].toString()) : <any>undefined;
            if (Array.isArray(_data["Organisations"])) {
                this.organisations = [] as KeyValuePair[];
                for (let item of _data["Organisations"])
                    this.organisations!.push(KeyValuePair.fromJS(item));
            }
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as KeyValuePair[];
                for (let item of _data["Roles"])
                    this.roles!.push(KeyValuePair.fromJS(item));
            }
        }

        return this;
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    isAdministrator(): boolean {
        return this.roles?.some(x => x.value.toLowerCase() === 'administrators');
    }

    isPublic(): boolean {
        // a user is "public" if they have no roles (other than the implicit public role)
        return this.roles?.length == 0;
    }

    hasRole(description: string): boolean {
        return this.roles?.some(x => x.value.toLowerCase() === description.toLowerCase());
    }
}

/** UserWithEntitlements */
export interface IUser extends IUserBase {
    /**  Gets or sets the username. */
    username: string | undefined;
    /** Gets or sets the DateTime the account was last locked. */
    lockedSince: DateTime | undefined;
    /** Gets or sets the DateTime the last security event email was sent. */
    securityNotificationSent: DateTime | undefined;
    /** Gets or sets the list of disabled organisations the user is entitled to. */
    organisationsDisabled: { [key: string]: string; } | undefined;
    /** Gets or sets a value indicating whether Two Factor Authentication is enabled for this user. */
    twoFactorAuthenticationEnabled: boolean;
    /** Gets or sets the account status property. */
    accountStatus: AccountStatus;
    /** Gets or sets the account type property. */
    accountType: AccountType;
    /** Gets or sets the property reset property. */
    passwordReset: PasswordReset | undefined;
    /** Gets or sets the list of enabled organisations the user is entitled to. */
    organisations: KeyValuePair[];
    /**  Gets or sets the list of roles. */
    roles: KeyValuePair[];
    /** Gets or sets a value indicating whether the user can access the form vault. */
    formVaultAccess?: boolean | undefined;
    /** Gets or sets the list of system entitlements. */
    systemEntitlements?: { [key: string]: AccessLevel; } | undefined;
    /** Gets or sets a value indicating whether
     * this iSolutions.iApply.DataContract.Security.UserWithEntitlements is a singly-signed-on user. */
    sso?: boolean | undefined;
    /** Gets or sets a value indicating whether single-signed-on user can sign out. */
    ssoWithLogout?: boolean | undefined;
    /** Gets or sets a value for SessionTimeOut. */
    sessionTimeOut?: number | undefined;
    /** Gets or sets a value for SessionIntervalCheck. */
    sessionIntervalCheck?: number | undefined;
    /** avatar (not in this version) */
    avatar?: string | undefined;
}

/** Guest User */
export class GuestUser extends UserBase implements IGuestUser {
    /**  Gets or sets the access GUID try count. */
    accessGuidTryCount: number;
    /** Gets or sets the passcode try count. */
    passcodeTryCount: number;
    /** Gets or sets the passcode. */
    passcode: string | undefined;
    /** Gets or sets the date and time the guest user invite was created. */
    inviteCreated: DateTime | undefined;
    /** Gets or sets the date and time the guest user passcode was requested. */
    passcodeRequested: DateTime | undefined;
    /**  Gets or sets the access GUID. */
    accessGuid: string | undefined;
    /** Gets or sets the account status property. */
    accountStatus: GuestAccountStatus;
    /** Gets or sets the id of application available for guest user. */
    applicationId: string | undefined;
    /** Gets or sets the available state of application for guest user. */
    applicationState: string | undefined;
    /** Gets or sets the available state of application after the guest user submits form. */
    applicationStateAfterSubmit: string | undefined;
    /**  Gets or sets the list of roles. */
    roles: KeyValuePair[];
    /** Gets or sets a value for SessionIntervalCheck. */
    sessionIntervalCheck?: number | undefined;
    /** avatar (not in this version) */
    avatar?: string | undefined;

    constructor(data?: IGuestUser) {
        super(data);
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["_id"]?.$oid;
            this.displayName = _data["DisplayName"];
            this.emailAddress = _data["EmailAddress"];
            this.avatar = _data["Avatar"];
            this.externalId = _data["ExternalId"];
            this.accessGuidTryCount = _data["AccessGuidTryCount"];
            this.passcodeTryCount = _data["PasscodeTryCount"];
            this.passcode = _data["Passcode"];
            this.inviteCreated = tryParseDate(_data["InviteCreated"]);
            this.passcodeRequested = _data["PasscodeRequested"];
            this.accessGuid = _data["AccessGuid"];
            this.accountStatus = _data["AccountStatus"];
            this.applicationId = _data["ApplicationId"];
            this.applicationState = _data["ApplicationState"];
            this.applicationStateAfterSubmit = _data["ApplicationStateAfterSubmit"];
            this.sessionIntervalCheck = _data["SessionIntervalCheck"];
            if (_data["ExtendedProperties"]) {
                this.extendedProperties = {} as any;
                for (let key in _data["ExtendedProperties"]) {
                    if (_data["ExtendedProperties"].hasOwnProperty(key))
                        (<any>this.extendedProperties)![key] = _data["ExtendedProperties"][key];
                }
            }
            if (Array.isArray(_data["Roles"])) {
                this.roles = [] as KeyValuePair[];
                for (let item of _data["Roles"])
                    this.roles!.push(KeyValuePair.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GuestUser {
        data = typeof data === 'object' ? data : {};
        let result = new GuestUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["_id"]["$oid"] = this.id;
        data["DisplayName"] = this.displayName;
        data["EmailAddress"] = this.emailAddress;
        data["ExternalId"] = this.externalId;
        if (this.extendedProperties) {
            data["ExtendedProperties"] = {};
            for (let key in this.extendedProperties) {
                if (this.extendedProperties.hasOwnProperty(key))
                    (<any>data["ExtendedProperties"])[key] = (<any>this.extendedProperties)[key];
            }
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["AccessGuidTryCount"] = this.accessGuidTryCount;
        data["PasscodeTryCount"] = this.passcodeTryCount;
        data["Passcode"] = this.passcode;
        data["InviteCreated"] = this.inviteCreated ? this.inviteCreated.toString() : <any>undefined;
        data["PasscodeRequested"] = this.passcodeRequested;
        data["AccessGuid"] = this.accessGuid;
        data["AccountStatus"] = this.accountStatus;
        data["ApplicationId"] = this.applicationId;
        data["ApplicationState"] = this.applicationState;
        data["ApplicationStateAfterSubmit"] = this.applicationStateAfterSubmit;
        data["SessionIntervalCheck"] = this.sessionIntervalCheck;
        return data;
    }

    isAdministrator(): boolean {
        return this.roles.some(x => x.value.toLowerCase() === 'administrators');
    }

    hasRole(description: string): boolean {
        return this.roles.some(x => x.value.toLowerCase() === description.toLowerCase());
    }

    canExpire(): boolean {
        return this.accountStatus === GuestAccountStatus.ApplicationLinkEmailed
        || this.accountStatus === GuestAccountStatus.PasscodeRequested;
    }
}

/** Guest User */
export interface IGuestUser extends IUserBase {
    /**  Gets or sets the access GUID try count. */
    accessGuidTryCount: number;
    /** Gets or sets the passcode try count. */
    passcodeTryCount: number;
    /** Gets or sets the passcode. */
    passcode: string | undefined;
    /** Gets or sets the date and time the guest user invite was created. */
    inviteCreated: DateTime | undefined;
    /** Gets or sets the date and time the guest user passcode was requested. */
    passcodeRequested: DateTime | undefined;
    /**  Gets or sets the access GUID. */
    accessGuid: string | undefined;
    /** Gets or sets the account status property. */
    accountStatus: GuestAccountStatus;
    /** Gets or sets the id of application available for guest user. */
    applicationId: string | undefined;
    /** Gets or sets the available state of application for guest user. */
    applicationState: string | undefined;
    /** Gets or sets the available state of application after the guest user submits form. */
    applicationStateAfterSubmit: string | undefined;
    /**  Gets or sets the list of roles. */
    roles: KeyValuePair[];
    /** Gets or sets a value for SessionIntervalCheck. */
    sessionIntervalCheck?: number | undefined;
    /** avatar (not in this version) */
    avatar?: string | undefined;
}

/** DTO for reset password input */
export class ForgetPasswordInput implements IForgetPasswordInput {
    /** username */
    username: string | undefined;
    /** the current site url */
    url?: string | undefined = null;
    /** organisation Id */
    organisationId?: string | undefined = null;

    constructor(data?: IForgetPasswordInput) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.url = _data["url"];
            this.organisationId = _data["organisationId"];
        }
    }

    static fromJS(data: any): ForgetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ForgetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["url"] = this.url;
        data["organisationId"] = this.organisationId;
        return data;
    }
}

/** DTO for reset password input */
export interface IForgetPasswordInput {
    /** username */
    username: string | undefined;
    /** the current site url */
    url?: string | undefined;
    /** organisation Id */
    organisationId?: string | undefined;
}

/** DTO for reset password input */
export class ResetPasswordInput implements IResetPasswordInput {
    /** Reset password token */
    token!: string | undefined;
    /** username */
    username!: string | undefined;
    /** New password */
    password!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["passwordChangeToken"];
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["passwordChangeToken"] = this.token;
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}

/** DTO for reset password input */
export interface IResetPasswordInput {
    /** Reset password token */
    token: string | undefined;
    /** username */
    username: string | undefined;
    /** New password */
    password: string | undefined;
}

export class RegisterUserInput implements IRegisterUserInput {
    userJson: string;
    password?: string | undefined = null;
    passwordOrganisationId?: string | undefined = null;

    constructor(data?: IRegisterUserInput) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userJson"] = this.userJson;
        data["password"] = this.password;
        data["passwordOrganisationId"] = this.passwordOrganisationId;
        return data;
    }
}

export interface IRegisterUserInput {
    userJson: string;
    password?: string | undefined;
    passwordOrganisationId?: string | undefined;
}

export class RegisterUserResponse implements IRegisterUserResponse {
    /** Gets or sets a value indicating whether it is success. */
    success: boolean;
    /** Gets or sets the user. */
    user: User | undefined;

    constructor(data?: IRegisterUserResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserResponse();
        result.init(data);
        return result;
    }
}

export interface IRegisterUserResponse {
    /** Gets or sets a value indicating whether it is success. */
    success: boolean;
    /** Gets or sets the user. */
    user: User | undefined;
}

/** Custom additional details for externally authenticated users. */
export class IExternalUserDetails implements IIExternalUserDetails {
    /** Gets or sets the name of the authentication provider. */
    authenticationProviderName!: string | undefined;
    /** Gets or sets the subject identifier. */
    subjectId!: string | undefined;
    /** Gets or sets additional properties. */
    properties!: { [key: string]: string; } | undefined;

    constructor(data?: IIExternalUserDetails) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationProviderName = _data["authenticationProviderName"];
            this.subjectId = _data["subjectId"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): IExternalUserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new IExternalUserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationProviderName"] = this.authenticationProviderName;
        data["subjectId"] = this.subjectId;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }
}

/** Custom additional details for externally authenticated users. */
export interface IIExternalUserDetails {
    /** Gets or sets the name of the authentication provider. */
    authenticationProviderName: string | undefined;
    /** Gets or sets the subject identifier. */
    subjectId: string | undefined;
    /** Gets or sets additional properties. */
    properties: { [key: string]: string; } | undefined;
}

export class VerifySessionResponse implements IVerifySessionResponse {
    success!: boolean;
    twoFactorActivationRequired?: boolean | undefined;
    twoFactorInProgress?: boolean | undefined;
    user?: User | undefined;
    redirect?: string | undefined;
    guestUser?: GuestUser | undefined;

    constructor(data?: IVerifySessionResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.twoFactorActivationRequired = _data["TwoFactorActivationRequired"];
            this.twoFactorInProgress = _data["TwoFactorInProgress"];
            this.success = _data["Success"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.redirect = _data["redirect"];
            this.guestUser = _data["guestUser"] ? GuestUser.fromJS(_data["guestUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VerifySessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySessionResponse();
        result.init(data);
        return result;
    }
}

export interface IVerifySessionResponse {
    success: boolean;
    twoFactorActivationRequired?: boolean | undefined;
    twoFactorInProgress?: boolean | undefined;
    user?: User | undefined;
    redirect?: string | undefined;
    guestUser?: GuestUser | undefined;
}

export class RemoveSessionResponse implements IRemoveSessionResponse {
    success!: boolean;
    redirect: string | undefined;

    constructor(data?: IRemoveSessionResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.redirect = _data["redirect"];
        }
    }

    static fromJS(data: any): RemoveSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Success"] = this.success;
        data["redirect"] = this.redirect;
        return data;
    }
}

export interface IRemoveSessionResponse {
    success: boolean;
    redirect: string | undefined;
}

/** PasswordReset enumeration. */
export enum PasswordReset {
    Locked = "Locked",
}

/** Input for validating a user account email address using a token link. */
export class VerifyUserEmailInput implements IVerifyUserEmailInput {
    username!: string | undefined;
    password!: string | undefined;
    email!: string | undefined;
    token!: string | undefined;

    constructor(data?: IVerifyUserEmailInput) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): VerifyUserEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyUserEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["email"] = this.email;
        data["token"] = this.token;
        return data;
    }
}

/** Input for validating a user account email address using a token link. */
export interface IVerifyUserEmailInput {
    username: string | undefined;
    password: string | undefined;
    email: string | undefined;
    token: string | undefined;
}

/** Respose with success and optional message  */
export class GenericSuccessResponse implements IGenericSuccessResponse {
    success: boolean;
    message?: string | undefined;

    constructor(data?: IGenericSuccessResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            if (_data['Message']) {
                this.message = _data['Message'];
            }
        }
    }

    static fromJS(data: any): GenericSuccessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenericSuccessResponse();
        result.init(data);
        return result;
    }
}

/** Respose with success and optional message  */
export interface IGenericSuccessResponse {
    success: boolean;
    message?: string | undefined;
}

/** Respose for HandleWebServiceException  */
export class SecurityErrorResponse implements ISecurityErrorResponse {
    success: boolean = false;
    message: string | undefined;
    sessionExpired: boolean = false;
    passwordExpired: boolean = false;

    constructor(data?: ISecurityErrorResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = !!_data["Success"];
            if (_data['Message']) {
                this.message = _data['Message'];
            }
            this.sessionExpired = !!_data["SessionExpired"];
            this.passwordExpired = !!_data["PasswordExpired"];
        }
    }

    static fromJS(data: any): SecurityErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityErrorResponse();
        result.init(data);
        return result;
    }
}

/** Respose for HandleWebServiceException */
export interface ISecurityErrorResponse {
    success: boolean;
    message: string | undefined;
    sessionExpired: boolean
}

/** password complexity requirements. */
export class PasswordRequirementsResponse implements IPasswordRequirementsResponse {
    /** Gets or sets a value indicating whether it is success. */
    success!: boolean;
    /** Gets or sets passwordComplexityRules. */
    passwordComplexityRules: PasswordComplexityRule[];

    constructor(data?: IPasswordRequirementsResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            if (Array.isArray(_data["PasswordComplexityRules"])) {
                this.passwordComplexityRules = [] as PasswordComplexityRule[];
                for (let item of _data["PasswordComplexityRules"])
                    this.passwordComplexityRules!.push(PasswordComplexityRule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PasswordRequirementsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordRequirementsResponse();
        result.init(data);
        return result;
    }
}

/** Two Factor Credentials Response */
export interface IPasswordRequirementsResponse {
    success: boolean;
    passwordComplexityRules: PasswordComplexityRule[] | undefined;
}

/** A rule that dictates how complex a given password must be. */
export class PasswordComplexityRule implements IPasswordComplexityRule {
    /** Gets or sets the regex which defines the rule. */
    regex!: string | undefined;
    /** Gets or sets the description of the rule. */
    description!: string | undefined;

    constructor(data?: IPasswordComplexityRule) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regex = _data["Regex"];
            this.description = _data["Description"];
        }
    }

    static fromJS(data: any): PasswordComplexityRule {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexityRule();
        result.init(data);
        return result;
    }
}

/** A rule that dictates how complex a given password must be. */
export interface IPasswordComplexityRule {
    /** Gets or sets the regex which defines the rule. */
    regex: string | undefined;
    /** Gets or sets the description of the rule. */
    description: string | undefined;
}

/** A response for validating guest access with specified request. */
export class VerifyGuestAccessResponse implements IVerifyGuestAccessResponse {
    success: boolean = false;
    valid: boolean = false;

    constructor(data?: IVerifyGuestAccessResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["Success"];
            this.valid = _data["Valid"];
        }
    }

    static fromJS(data: any): VerifyGuestAccessResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyGuestAccessResponse();
        result.init(data);
        return result;
    }
}

/** A response for validating guest access with specified request. */
export interface IVerifyGuestAccessResponse {
    success: boolean;
    valid: boolean;
}

/** DTO for guest user authentication */
export class AuthenticateGuestInput implements IAuthenticateGuest {
    accessGuid!: string | undefined;
    email!: string | undefined;

    constructor(data?: IAuthenticateGuest) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessGuid = _data["accessGuid"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AuthenticateGuestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateGuestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessGuid"] = this.accessGuid;
        data["email"] = this.email;
        return data;
    }
}

/** DTO for guest user authentication */
export interface IAuthenticateGuest {
    /** Reset password token */
    accessGuid: string | undefined;
    /** username */
    email: string | undefined;
}

/** The response object returned from guest user authentication requests. */
export class GuestUserAuthResponse implements IGuestUserAuthResponse {
    success: boolean;
    twoFactorAuthenticationRequired?: boolean | undefined;
    user?: GuestUser | undefined;

    constructor(data?: IGuestUserAuthResponse) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.twoFactorAuthenticationRequired = _data["TwoFactorAuthenticationRequired"];
            this.success = _data["Success"];
            this.user = _data["User"] ? GuestUser.fromJS(_data["User"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GuestUserAuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GuestUserAuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TwoFactorAuthenticationRequired"] = this.twoFactorAuthenticationRequired;
        data["Success"] = this.success;
        data["User"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

/** The response object returned from guest user authentication requests. */
export interface IGuestUserAuthResponse {
    success: boolean;
    twoFactorAuthenticationRequired?: boolean | undefined;
    user?: GuestUser | undefined;
}
